import React from "react";

function PFDateAndDesc({...props}) {
    return (
        <>
            <div className="text-center fs-5">
                Winchester Porchfest 2026
            </div>
            <div className="text-center fs-3">
                <strong>Saturday June 13, 12 - 5pm</strong>
            </div>
            <div className="text-center fs-5">
                &#x1F4A7; Rain date: Sunday June 14
            </div>
        </>
    );
}

export default PFDateAndDesc;